import { createSlice } from "@reduxjs/toolkit";
import { ApplicationRootState } from "types";
import { GameStateType } from "types/game";

import { extraReducers } from "./game.extraReducers";
import { reducers } from "./game.reducers";

export const initialState: GameStateType = {
  isLoading: false,

  dataCategoryDetails: [],
  dataCategoryGameAll: [],

  dataCategoryGameFilter: [],
  dataSubGame: {
    data: [],
    totalCount: 0,
    totalPages: 0,
  },
  categoryCurrent: "",
  typeGame: "",
  dataSubGamesFavourite: [],
  isSubGamesFavouriteLoading: false,
};

const gameSlice = createSlice({
  name: "game",
  initialState,
  reducers,
  extraReducers,
});

export const {
  resetDataSubGame,
  resetDataCategoryGameFilter,
  setCategoryCurrent,
  updateSubGamesFavourite,
} = gameSlice.actions;

export const selectIsLoading = (state: ApplicationRootState) =>
  state.game.isLoading;

export const selectDataCategoryGameFilter = (state: ApplicationRootState) =>
  state.game.dataCategoryGameFilter;

export const selectDataGameAll = (state: ApplicationRootState) =>
  state.game.dataCategoryGameAll;

export const selectCategoryDetails = (state: ApplicationRootState) =>
  state.game.dataCategoryDetails;

export const selectDataSubGame = (state: ApplicationRootState) =>
  state.game.dataSubGame;

export const selectDataSubGameFavourite = (state: ApplicationRootState) =>
  state.game.dataSubGamesFavourite;

export const selectIsSubGamesFavouriteLoading = (state: ApplicationRootState) =>
  state.game.isSubGamesFavouriteLoading;

export default gameSlice.reducer;
